import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { Check } from "lucide-react";
import { MISSION, IMAGES } from "@/data/content";

const CHAPTERS = [
  {
    n: "01",
    title: "Who we are",
    body:
      "ADK SOLUTIONS offers premium agricultural machinery that meets the evolving needs of modern farming. We deliver reliable, durable, high-performance farm implements that help farmers increase productivity, improve soil health, conserve water, and reduce operational costs.",
  },
  {
    n: "02",
    title: "Why we exist",
    body:
      "Our mission is to bridge the gap between advanced agricultural technology and farmers — delivering world-class equipment backed by exceptional customer service and technical support. Whether you're an individual farmer, a contractor, or an agricultural business, we're committed to higher yields with efficient farming solutions.",
  },
  {
    n: "03",
    title: "Our vision",
    body:
      "To become one of India's most trusted agricultural machinery providers by delivering innovative, reliable, and affordable farming solutions that empower every farmer we serve.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about" className="relative bg-brand-cream py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-brown mb-4">About ADK Solutions</p>
          <h2 className="font-heading font-bold text-brand-ink tracking-tight text-3xl sm:text-5xl max-w-3xl leading-[1.05]">
            Bridging advanced farm technology and the farmers who feed India.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7 space-y-12">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.05}>
                <div className="grid grid-cols-[auto_1fr] gap-6 border-t border-brand-ink/10 pt-6">
                  <span className="font-mono text-4xl font-bold text-brand-green/25 leading-none">{c.n}</span>
                  <div>
                    <h3 className="font-heading font-bold text-xl sm:text-2xl text-brand-ink tracking-tight mb-3">{c.title}</h3>
                    <p className="text-brand-ink/70 leading-relaxed max-w-xl">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="relative clip-frame overflow-hidden">
                <motion.img
                  src={IMAGES.farmer}
                  alt="Progressive farmer operating agricultural machinery"
                  className="h-[360px] lg:h-[440px] w-full object-cover"
                  initial={{ scale: 1.15 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                />
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-6 rounded-2xl bg-brand-blueDark text-brand-cream p-7">
                <h3 className="font-heading font-bold text-lg mb-4">Our Mission</h3>
                <ul className="space-y-3">
                  {MISSION.map((m) => (
                    <li key={m} className="flex items-start gap-3 text-sm text-brand-cream/85">
                      <Check className="size-4 mt-0.5 shrink-0 text-brand-greenLight" />
                      {m}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
